


































import { Component, Mixins, Prop } from "vue-property-decorator";
import AdminBrandId from "@/mixins/adminBrandId";
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    "timeline-component": () =>
      import("@/components/app/global/timelineComponent/index.vue")
  }
})
export default class AdminUsers extends Mixins(AdminBrandId) {
  @Prop({ default: () => () => [] })
  public routes!: () => any;

  public openUserCreateModal() {
    return this.$store.dispatch(`data/${DataModules.USERS}/openCreateModal`);
  }
}
